import { combineReducers } from 'redux';
import auth from './auth';
import slack from './slack';
import facebook from './facebook';
import devices from './devices';
import invites from './invites';
import guest from './guest';
import webex from './webex';
import notifications from './notifications';

const reducer = combineReducers({
  auth,
  slack,
  facebook,
  devices,
  invites,
  guest,
  notifications,
  webex,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js